import { PALETTE } from "../indicators/palette";

// Sizes in CSS pixels. A new drawing: the first colour of the PO palette, 1 px (09-trend-line-handles.jpg)
export const DRAWING_DEFAULT_COLOR = PALETTE.LIME;
export const DRAWING_DEFAULT_WIDTH_PX = 1;
// The thickness picker offers these and the whole numbers between them
export const DRAWING_MIN_WIDTH_PX = 1;
export const DRAWING_MAX_WIDTH_PX = 5;
// Backgrounds of a channel, a rectangle and a pitchfork: their colour at this opacity (po-chart-visual-spec.md §7.5)
export const DRAWING_FILL_OPACITY = 0.2;
// Segment ends overlap by half the width, so the corners of a rectangle are closed
export const DRAWING_LINE_CAP_RATIO = 0.5;

// Dashes of a line, in shares of its width: thick lines get long dashes, the caps of their ends would close short gaps
export const DRAWING_DASH_LENGTH_RATIO = 4;
export const DRAWING_DASH_GAP_RATIO = 4;
// Levels 0 and 1 of Fibonacci Retracement against the others
export const DRAWING_FIBONACCI_BOLD_WIDTH_RATIO = 2;
// The grid of Fibonacci Fan: thin and dimmer than its rays
export const DRAWING_FAN_GRID_WIDTH_PX = 1;
export const DRAWING_FAN_GRID_OPACITY = 0.35;

// Handles: white circles of about 8 px (po-chart-visual-spec.md §7.2), bigger under a finger
export const DRAWING_HANDLE_RADIUS_PX = 4;
export const DRAWING_HANDLE_RADIUS_TOUCH_PX = 7;
// A handle of a line across the pane stays this far from the pane edge
export const DRAWING_HANDLE_EDGE_INSET_PX = 12;

// Hit-test distances; a finger gets a 32 × 32 px area (E16)
export const DRAWING_LINE_HIT_PX = 5;
export const DRAWING_HANDLE_HIT_PX = 8;
export const DRAWING_TOUCH_HIT_PX = 16;

// Labels of the Fibonacci levels: this far from the side of the drawing
export const DRAWING_LEVEL_LABEL_OFFSET_X_PX = 4;
export const DRAWING_LEVEL_LABEL_OFFSET_Y_PX = 8;

// A burst of changes is saved once, this long after the last one
export const DRAWINGS_SAVE_DEBOUNCE_MS = 500;

export const DRAWING_CURSOR = {
  HANDLE: "move",
  SHAPE: "pointer",
};
